import { Button } from '@mui/material';
import type { InvoiceOverview } from '@vy/api-definition';
import { notDefined } from '@vy/null';
import React from 'react';
import { useDialog } from '../../../../../../hooks/use-dialog';
import { RawResponseDialog } from './RawResponseDialog';

type MarketplaceRawResponseCellProps = {
  row: InvoiceOverview;
};

export const MarketplaceRawResponseCell: React.FC<MarketplaceRawResponseCellProps> = ({ row }) => {
  const rawResponse = row.marketplaceSyncStatus?.rawResponse;
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  if (notDefined(rawResponse)) {
    return <span>—</span>;
  }

  return (
    <>
      <Button
        variant="text"
        size="small"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleOpen();
        }}
        sx={{ textTransform: 'none', fontSize: '0.8125rem' }}
      >
        View Response
      </Button>
      {isDialogOpen && (
        <RawResponseDialog rawResponse={rawResponse} open={isDialogOpen} onClose={handleClose} />
      )}
    </>
  );
};
